import tracking from 'dibs-tracking';

function trackTileImpression({ tiles, indexOffset }) {
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: tiles.map((tile, index) => ({
            id: tile.tileType,
            name: 'discover tile',
            creative: tile.ctaUrl,
            position: indexOffset + index + 1, // start counting at 1 + indexOffset
        })),
    });
}

function trackTileClick({ tileType, ctaUrl, index }) {
    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [
            {
                id: tileType,
                name: 'discover tile',
                creative: ctaUrl,
                position: index + 1, // start counting at 1
            },
        ],
    });
}

export { trackTileImpression, trackTileClick };
